import { observer } from 'mobx-react';
import React from 'react';
import { IItemBranchesModifier } from '../types/itemBranchesModifier';
import ModifierOptionRow from './ModifierOptionRow';

export interface IRowProps {
  modifier: IItemBranchesModifier;
}

const ItemBranchesModifiersRow: React.FC<IRowProps> = ({ modifier }: IRowProps): JSX.Element | null => {
  return (
    <div className="border-bottom">
      {modifier.options?.map((option, optionIndex) => (
        <ModifierOptionRow key={option.option_id} modifier={modifier} option={option} isFirst={optionIndex === 0} />
      ))}
    </div>
  );
};

export default observer(ItemBranchesModifiersRow);
